/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountData,
  AnalysisHistory,
  UpdateAccountUsageRequest,
} from '../models/index';
import {
    AccountDataFromJSON,
    AccountDataToJSON,
    AnalysisHistoryFromJSON,
    AnalysisHistoryToJSON,
    UpdateAccountUsageRequestFromJSON,
    UpdateAccountUsageRequestToJSON,
} from '../models/index';

export interface UpdateAccountUsageOperationRequest {
    updateAccountUsageRequest: UpdateAccountUsageRequest;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * Gibt Informationen zum aktuellen Benutzer-Account zurück
     * Account-Informationen
     */
    async getAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountDataFromJSON(jsonValue));
    }

    /**
     * Gibt Informationen zum aktuellen Benutzer-Account zurück
     * Account-Informationen
     */
    async getAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountData> {
        const response = await this.getAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gibt die Analyse-Historie des Benutzers zurück
     * Analyse-Historie
     */
    async getAccountHistoryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AnalysisHistory>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AnalysisHistoryFromJSON));
    }

    /**
     * Gibt die Analyse-Historie des Benutzers zurück
     * Analyse-Historie
     */
    async getAccountHistory(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AnalysisHistory>> {
        const response = await this.getAccountHistoryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Aktualisiert die Nutzungsdaten (nach Analyse)
     * Nutzungsdaten aktualisieren
     */
    async updateAccountUsageRaw(requestParameters: UpdateAccountUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountData>> {
        if (requestParameters.updateAccountUsageRequest === null || requestParameters.updateAccountUsageRequest === undefined) {
            throw new runtime.RequiredError('updateAccountUsageRequest','Required parameter requestParameters.updateAccountUsageRequest was null or undefined when calling updateAccountUsage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/usage`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountUsageRequestToJSON(requestParameters.updateAccountUsageRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountDataFromJSON(jsonValue));
    }

    /**
     * Aktualisiert die Nutzungsdaten (nach Analyse)
     * Nutzungsdaten aktualisieren
     */
    async updateAccountUsage(requestParameters: UpdateAccountUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountData> {
        const response = await this.updateAccountUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
